import PropTypes from "prop-types";
import { Icon, Text } from "@artprov/design-system";

const cn = (...classes) => classes.filter(Boolean).join(" ");

export const IconBody = ({ variant = "success" }) => {
  const iconName = {
    success: "check_circle",
    error: "cancel",
    warning: "error",
  }[variant];

  const iconColor = {
    success: "text-success-10",
    error: "text-error-10",
    warning: "text-warning-10",
  }[variant];

  return (
    <Icon icon={iconName} className="pb-5" classNameIcon={cn(iconColor)} size="extra-large" />
  );
};

IconBody.propTypes = {
  variant: PropTypes.oneOf(["success", "error", "warning"]),
};

export const Title = ({ children, className = "" }) => {
  return (
    <Text variant="h5" className={cn("text-primary-10 pb-4 h-min", className)}>
      {children}
    </Text>
  );
};

Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export const Message = ({ children, className = "" }) => {
  return (
    <Text variant="body1" className={cn("h-min flex text-center", className)}>
      {children}
    </Text>
  );
};

Message.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default function MessageHeader({ variant = "success", title, description, className = "", titleClassName = "" }) {
  return (
    <div className={cn("w-full flex items-center justify-center flex-col", className)}>
      <IconBody variant={variant} />
      {title && <Title className={titleClassName}>{title}</Title>}
      {description && <Message className="px-4">{description}</Message>}
    </div>
  );
}

MessageHeader.propTypes = {
  variant: PropTypes.oneOf(["success", "error", "warning"]),
  title: PropTypes.node,
  description: PropTypes.node,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
};